import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/icons/info.svg'
import _imports_1 from '@/assets/icons/check-green.svg'
import _imports_2 from '@/assets/icons/comment.svg'


const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "container flex flex-col bg-white w-full mb-4"
}
const _hoisted_3 = { class: "flex flex-row items-center mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-2xl mr-2 capitalize"
}
const _hoisted_5 = { class: "text-2xl font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_7 = { class: "flex-grow bg-background shadow-inner" }
const _hoisted_8 = { class: "container py-8" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_11 = { class: "flex flex-col 2xl:flex-row items-stretch mb-8" }
const _hoisted_12 = { class: "flex flex-row items-start bg-white rounded-2xl w-full text-sm xl:text-md 2xl:text-sm 2xl:w-full p-8" }
const _hoisted_13 = { class: "flex flex-col w-6/12" }
const _hoisted_14 = { class: "flex flex-row justify-between items-center bg-primary text-white rounded-l-full px-4 py-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mt-4 px-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Payroll initiation and setup"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, "We'll start calculating payroll based on the number of employees, salaries, and reimbursements submitted during this period.")
], -1)
const _hoisted_17 = { class: "flex flex-col w-3/12" }
const _hoisted_18 = { class: "flex flex-row justify-between items-center bg-orange-500 text-white px-4 py-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mt-4 px-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Final payroll calculation"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, "These are the final days to approve previously submitted reimbursements to include them in this payroll.")
], -1)
const _hoisted_21 = { class: "flex flex-col w-3/12" }
const _hoisted_22 = { class: "flex flex-row justify-between items-center bg-green-500 text-white rounded-r-full px-4 py-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_24 = { class: "flex flex-col mt-4 px-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Payroll payment disbursement", -1)
const _hoisted_26 = { class: "text-gray-500 mt-2" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Payment will be automatically billed with your registered ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_29 = {
  key: 0,
  class: "relative flex flex-col justify-between flex-grow bg-black rounded-2xl p-8 mt-8 2xl:mt-0 2xl:ml-8"
}
const _hoisted_30 = { class: "flex flex-row justify-between mb-4" }
const _hoisted_31 = { class: "flex flex-col" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "font-sm text-gray-500" }, " Employees ", -1)
const _hoisted_33 = { class: "text-3xl text-white font-bold" }
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "font-sm text-gray-500" }, " Total ", -1)
const _hoisted_36 = { class: "flex flex-row items-end text-white font-bold" }
const _hoisted_37 = {
  key: 0,
  class: "text-3xl"
}
const _hoisted_38 = {
  key: 1,
  class: "text-3xl"
}
const _hoisted_39 = { class: "text-lg uppercase ml-2 relative bottom-1" }
const _hoisted_40 = {
  key: 0,
  class: "absolute bg-background bottom-2 2xl:bottom-24 right-2 2xl:bg-background bg-opacity-90 rounded shadow p-2 w-1/2 2xl:w-full"
}
const _hoisted_41 = { class: "uppercase" }
const _hoisted_42 = { class: "flex flex-row items-start justify-between" }
const _hoisted_43 = {
  key: 0,
  class: "text-sm text-white w-2/3"
}
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" We will automatically bill the payment on ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_46 = { key: 1 }
const _hoisted_47 = ["href"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("button", { class: "flex flex-row items-center border-2 border-green-500 text-green-500 rounded-full px-4 py-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-4 h-4 mr-3"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Paid")
], -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["href"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("button", { class: "space-y-3 text-white px-4 py-2 rounded-full border-2 border-white" }, " Pay now ", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 0,
  class: "bg-white rounded-2xl p-8 mb-8"
}
const _hoisted_54 = { class: "flex flex-row justify-between" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "Timeline", -1)
const _hoisted_56 = { class: "flex flex-row mt-4" }
const _hoisted_57 = { class: "w-full" }
const _hoisted_58 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_59 = {
  key: 1,
  class: "w-full"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex items-center justify-center w-1/12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "mt-2"
  })
], -1)
const _hoisted_62 = { class: "flex flex-col w-11/12 ml-2" }
const _hoisted_63 = { class: "flex flex-row items-center w-full" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "commented:", -1)
const _hoisted_65 = { class: "mt-4" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-4" }, null, -1)
const _hoisted_67 = { class: "realtive bg-white rounded-2xl pt-8 overflow-x-scroll overflow-y-visible" }
const _hoisted_68 = { class: "table-auto w-full" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-gray-500" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Employee"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Gross Salary"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Employer Tax"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "EoY & Savings Fund Bonus"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Benefits"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal px-2" }, "Reimbursements"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Axented Fee"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Total")
  ])
], -1)
const _hoisted_70 = { class: "px-4 w-2/12" }
const _hoisted_71 = { class: "px-2 w-1/12" }
const _hoisted_72 = { class: "bg-background rounded-full px-4 py-1" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "px-2 w-1/12" }
const _hoisted_76 = { class: "bg-background rounded-full px-4 py-1" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = ["onMouseover"]
const _hoisted_80 = { key: 0 }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "EoY Bonus", -1)
const _hoisted_82 = { key: 1 }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "EoY Bonus", -1)
const _hoisted_84 = { class: "mt-2" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Savings Fund", -1)
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Savings Fund", -1)
const _hoisted_89 = { class: "bg-background rounded-full z-40 px-4 py-1" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = ["onMouseover"]
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { class: "font-semibold" }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { class: "font-semibold" }
const _hoisted_97 = { class: "bg-background rounded-full z-40 px-4 py-1" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "px-2 w-1/12" }
const _hoisted_101 = { class: "bg-background rounded-full px-4 py-1" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { class: "px-2 w-1/12" }
const _hoisted_105 = { class: "bg-background rounded-full px-4 py-1" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = { class: "px-2 w-1/12" }
const _hoisted_109 = { class: "bg-black text-white rounded-full px-4 py-1" }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { key: 1 }
const _hoisted_112 = {
  key: 1,
  class: "flex flex-col mt-8 mb-4"
}
const _hoisted_113 = {
  key: 0,
  class: "font-semibold text-xl mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_ModalClarification = _resolveComponent("ModalClarification")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_CardExtraCharge = _resolveComponent("CardExtraCharge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    (!_ctx.loading && !_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.payroll.company)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.payroll.company.visible_name) + " Payroll:", 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_DateFormatter, {
                date: _ctx.payroll.start_date
              }, null, 8, ["date"]),
              _hoisted_6,
              _createVNode(_component_DateFormatter, {
                date: _ctx.payroll.end_date
              }, null, 8, ["date"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.error)
                ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_DateFormatter, {
                              date: _ctx.payroll.start_date
                            }, null, 8, ["date"]),
                            _hoisted_15,
                            _createVNode(_component_DateFormatter, {
                              date: _ctx.payroll.setup_end_date
                            }, null, 8, ["date"])
                          ]),
                          _hoisted_16
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_DateFormatter, {
                              date: _ctx.payroll.approval_start_date
                            }, null, 8, ["date"]),
                            _hoisted_19,
                            _createVNode(_component_DateFormatter, {
                              date: _ctx.payroll.approval_end_date
                            }, null, 8, ["date"])
                          ]),
                          _hoisted_20
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_DateFormatter, {
                              date: _ctx.payroll.payment_start_date
                            }, null, 8, ["date"]),
                            _hoisted_23,
                            _createVNode(_component_DateFormatter, {
                              date: _ctx.payroll.end_date
                            }, null, 8, ["date"])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/settings/billing'))),
                                class: "text-primary"
                              }, " payment method"),
                              _hoisted_28
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.payroll.payrolls)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.meta.total_users), 1)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("div", _hoisted_36, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, " $" + _toDisplayString((_ctx.meta.payrolls_total / 100).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })), 1))
                                    : (_ctx.currency === 'mxn')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, " $" + _toDisplayString((
                            (_ctx.meta.payrolls_total * _ctx.meta.payrolls_exchange_rate_mxn) /
                            100
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })), 1))
                                      : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.currency), 1),
                                  _createElementVNode("img", {
                                    src: _imports_0,
                                    class: "h-4 w-4 ml-1 relative bottom-1",
                                    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = true)),
                                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = false))
                                  }, null, 32)
                                ])
                              ]),
                              (_ctx.showTooltip)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createElementVNode("p", null, [
                                      _createTextVNode(" This amount includes $" + _toDisplayString((_ctx.meta.payroll_stripe_handling_fee / 100).toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )) + " ", 1),
                                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.currency), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.meta.default_payment_method === "us_bank_account"
                          ? "ACH Direct Debit"
                          : "Credit Card") + " processing fee. ", 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              (_ctx.payroll.stripe_invoice_status !== 'paid')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                    _hoisted_44,
                                    _createVNode(_component_DateFormatter, {
                                      date: _ctx.payroll.payment_start_date
                                    }, null, 8, ["date"]),
                                    _hoisted_45
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_46)),
                              (_ctx.payroll.stripe_invoice_status === 'paid')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    href: _ctx.payroll.stripe_invoice_url,
                                    target: "_blank"
                                  }, _hoisted_49, 8, _hoisted_47))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 3,
                                    href: _ctx.payroll.stripe_invoice_url,
                                    target: "_blank"
                                  }, _hoisted_52, 8, _hoisted_50))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.timeline.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _hoisted_55,
                            _createVNode(_component_ModalClarification, {
                              newComment: _ctx.newComment,
                              "onUpdate:newComment": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newComment) = $event)),
                              timelineId: _ctx.timeline[0].id
                            }, null, 8, ["newComment", "timelineId"])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              (_ctx.timeline.length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, " There is no additional event or activity requested in this payroll. "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeline, (event, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: i,
                                        class: "w-full"
                                      }, [
                                        (event.comments.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.comments, (comment, j) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: j,
                                                  class: _normalizeClass(["flex flex-row items-start w-full", { 'mt-2': j > 0 }])
                                                }, [
                                                  _hoisted_61,
                                                  _createElementVNode("div", _hoisted_62, [
                                                    _createElementVNode("div", _hoisted_63, [
                                                      _createVNode(_component_UserCard, {
                                                        firstName: comment.user.first_name,
                                                        lastName: comment.user.last_name
                                                      }, null, 8, ["firstName", "lastName"]),
                                                      _hoisted_64
                                                    ]),
                                                    _createElementVNode("span", _hoisted_65, _toDisplayString(comment.content), 1),
                                                    _hoisted_66
                                                  ])
                                                ], 2))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("table", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payroll.payrolls, (emp, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: i,
                              class: "align-middle text-right border-t border-gray-300"
                            }, [
                              _createElementVNode("td", _hoisted_70, [
                                _createVNode(_component_UserCard, {
                                  id: emp.employee_id,
                                  firstName: emp.first_name,
                                  lastName: emp.last_name,
                                  position: emp.job_title,
                                  class: "my-4"
                                }, null, 8, ["id", "firstName", "lastName", "position"])
                              ]),
                              _createElementVNode("td", _hoisted_71, [
                                _createElementVNode("div", _hoisted_72, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_73, " $" + _toDisplayString((emp.gross_salary / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_74, " $" + _toDisplayString(((emp.gross_salary * emp.exchange_rate) / 100).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )), 1))
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_77, " $" + _toDisplayString((emp.employer_tax / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_78, " $" + _toDisplayString(((emp.employer_tax * emp.exchange_rate) / 100).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )), 1))
                                ])
                              ]),
                              _createElementVNode("td", {
                                class: "static px-2 w-1/12",
                                onMouseover: ($event: any) => (_ctx.showBonusesTooltip(emp.id)),
                                onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hoverBonus = ''))
                              }, [
                                (_ctx.hoverBonus === emp.id)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "absolute z-50 flex flex-col items-start justify-start text-left bg-white border border-primary p-4 rounded overflow-y-auto",
                                      style: _normalizeStyle(`margin-top: -${_ctx.newMargin}px;`)
                                    }, [
                                      _createElementVNode("div", null, [
                                        (_ctx.currency === 'usd')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                                              _hoisted_81,
                                              _createTextVNode(": $" + _toDisplayString((emp.christmas_bonus / 100).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.currency === 'mxn')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                                              _hoisted_83,
                                              _createTextVNode(": $" + _toDisplayString((
                                (emp.christmas_bonus * emp.exchange_rate) /
                                100
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_84, [
                                        (_ctx.currency === 'usd')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_85, [
                                              _hoisted_86,
                                              _createTextVNode(": $" + _toDisplayString((emp.saving_fund_bonus / 100).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.currency === 'mxn')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_87, [
                                              _hoisted_88,
                                              _createTextVNode(": $" + _toDisplayString((
                                (emp.saving_fund_bonus * emp.exchange_rate) /
                                100
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 4))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_89, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_90, " $" + _toDisplayString((emp.bonuses_total / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_91, " $" + _toDisplayString((
                              (emp.bonuses_total * emp.exchange_rate) /
                              100
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                ])
                              ], 40, _hoisted_79),
                              _createElementVNode("td", {
                                class: "static px-2 w-1/12",
                                onMouseover: ($event: any) => (_ctx.showBenefits(emp.id)),
                                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hover = ''))
                              }, [
                                (_ctx.hover === emp.id && emp.benefits.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      id: "tooltip",
                                      class: "absolute z-50 flex flex-col items-start justify-start text-left bg-white border border-primary p-4 rounded overflow-y-auto",
                                      style: _normalizeStyle(`margin-top: -${_ctx.newMargin}px;`)
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emp.benefits, (benefit, j) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: j,
                                          class: _normalizeClass({ 'mt-2': j > 0 })
                                        }, [
                                          (_ctx.currency === 'usd')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_93, [
                                                _createElementVNode("span", _hoisted_94, _toDisplayString(benefit.name), 1),
                                                _createTextVNode(": $" + _toDisplayString((benefit.value / 100).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.currency === 'mxn')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_95, [
                                                _createElementVNode("span", _hoisted_96, _toDisplayString(benefit.name), 1),
                                                _createTextVNode(": $" + _toDisplayString(((benefit.value * emp.exchange_rate) / 100).toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                    ], 4))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_97, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_98, " $" + _toDisplayString((emp.benefits_total / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_99, " $" + _toDisplayString((
                              (emp.benefits_total * emp.exchange_rate) /
                              100
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                ])
                              ], 40, _hoisted_92),
                              _createElementVNode("td", _hoisted_100, [
                                _createElementVNode("div", _hoisted_101, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_102, " $" + _toDisplayString((emp.reimbursements_total / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_103, " $" + _toDisplayString((
                              (emp.reimbursements_total * emp.exchange_rate) /
                              100
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_104, [
                                _createElementVNode("div", _hoisted_105, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_106, " $" + _toDisplayString((emp.axelerate_percent / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_107, " $" + _toDisplayString((
                              (emp.axelerate_percent * emp.exchange_rate) /
                              100
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_108, [
                                _createElementVNode("div", _hoisted_109, [
                                  (_ctx.currency === 'usd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_110, " $" + _toDisplayString((emp.total / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_111, " $" + _toDisplayString(((emp.total * emp.exchange_rate) / 100).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )), 1))
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    (_ctx.payroll.extra_charges)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                          (_ctx.payroll.extra_charges.length > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_113, "Extra charges"))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payroll.extra_charges, (charge, i) => {
                            return (_openBlock(), _createElementBlock("div", { key: i }, [
                              _createVNode(_component_CardExtraCharge, {
                                extraCharge: charge,
                                showName: false,
                                class: "mb-4"
                              }, null, 8, ["extraCharge"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
      ])
    ])
  ]))
}